<template>

	<Modal 
		:width="800"
		:title="title"
		@close="close"
	>

		<template v-slot:content>

			<form class="form" @submit.prevent="addTag">

				<div :class="{ 'input-wrap': true }" @mouseenter="inputWrapFocus=true" @mouseleave="inputWrapFocus=false">

					<input type="text" :placeholder="placeholder" v-model="tag" @keyup="processTag()" @focus="inputFocus=true" @blur="inputFocus=false">

					<span class="add-tag" @click="addTag" v-if="( inputFocus || inputWrapFocus ) && tag !== ''">Add </span>

				</div>

				<p v-if="errorMessage != '' && tag != ''" class="error-message">{{ errorMessage }}</p>

				<div class="current-tags">

					<span 
						class="disc has-delete green"
						v-for="(tagName, tagIndex) in tags" 
						:key="'tag1-'+tagIndex"
					>
						{{tagName}}
						<span 
							class="delete" 
							@click="tags.splice(tagIndex, 1); needsUpdate = true"
						>x</span>
					</span> 

				</div>

				<span :class="{'large-button': true, 'flip-colours':!!settings.flipButton, 'white-hover':!!settings.flipButton,save:true}" @click="saveTags" v-if="!!settings.needsUpdateAlways || ( needsUpdate && tag === '' && !settings.saveOnClose )">
					{{buttonText}}<span class="button-description" v-if="!returnOnly"><br>(these will be published right away)</span>
				</span>

				<div class="available-tags" v-if="availableTags.length>0">

					<h3 v-html="unusedTitleProcessed" />

					<span 
						class="disc clickable orange"
						v-for="(tagName, tagIndex) in availableTags" 
						:key="'tag2-'+tagIndex"
						@click="addTag(tagName)"
					>
						{{tagName}}

					</span> 

				</div>

				<slot name="editor" />

			</form>

		</template>

	</Modal>

</template>

<script>
import { mapMutations } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import Modal from './Display/Modal.vue'
export default {
	name: 'Tagger',
	components: { Modal },
	props: {
		settings: Object,
		domains: Array,
		lowerCaseTags: {
			type: Boolean,
			default: true
		},
		unusedTitle: {
			type: String,
			default: ''
		},
		removeCharacters: {
			type: Array,
			default: function () {
				return [];
			}
		}
	},
	data() {

		return {
			tag: '',
			tags: [],
			inputFocus: false,
			inputWrapFocus: false,
			errorMessage: '',
			needsUpdate: false
		}

	},
	watch: {
		settings: {
			handler(newVal) {
			
			},
			deep: true,
			immediate: true
		}
	},
	
	computed: { 
		returnOnly () {

			return typeof this.settings.returnOnly !== 'undefined' ? !!this.settings.returnOnly : false;

		},
		hasSettings () {

			return !!this.settings;

		},
		unusedTitleProcessed () {

			if ( this.unusedTitle ) return this.unusedTitle;

			return 'Unused '+this.tagNames+' (click to add)';

		},
		availableTags() {

			let avTags = typeof this.settings.availableTags !== 'undefined' ? this.settings.availableTags : [], avTags2 = [];

			avTags.forEach( function (t) {

				if ( 
					this.tags.indexOf(t) < 0 && 
					( this.tag === '' || t.search(this.tag) >= 0 )
				) {

					avTags2.push(t);

				}

			}.bind(this));

			return avTags2;

		},
		limit () {

			return typeof this.settings.limit !== 'undefined' ? this.settings.limit : 0;

		},
		buttonText () {

			return typeof this.settings.buttonText !== 'undefined' ? this.settings.buttonText : 'Save Changes';

		},

		title () {

			if ( typeof this.settings.title !== 'undefined' ) {

				return this.settings.title;

			}

			return this.settings.type === 'domains' ? 'Add/Edit Domains' : 'Add/Edit Tags';

		},

		placeholder () {

			if ( typeof this.settings.placeholder !== 'undefined' ) {

				return this.settings.placeholder;

			}

			return 'Type/paste a '+this.tagName.toLowerCase()+' and hit enter';

		},

        tagName () {

        	if ( typeof this.settings.tagName !== 'undefined' ) return this.settings.tagName;

        	let n = 'Tag';

			if ( this.settings.type === 'domains' ) {

				n = 'Domain';

			}

			if ( this.settings.type === 'emails' ) {

				n = 'Email Address';

			}

			return n;

        },

		tagNames () {

			if ( this.tagName.substring(this.tagName.length-1) === 's' ) return this.tagName + "es";

        	return this.tagName + "s";

        }

    },
	mounted() {

		if ( typeof this.settings.tags !== 'undefined' ) {

			this.settings.tags.forEach( function (tag) {
				this.tags.push(tag.toString());
			}.bind(this));

		}

	},

	methods: {

		...mapMutations('general',['updateLoadingText']),
		...mapMutations('forms',['addUpdateForm']),

		processTag() {

			if ( this.lowerCaseTags ) this.tag = this.tag.toLowerCase();

			this.removeCharacters.forEach( function (char) {

				this.tag = this.tag.replace(char, '');

			}.bind(this));

		},

		addTag (tag) {

			if ( this.limit > 0 && this.limit === this.tags.length ) {

				this.$snotify.error('You can only add ' + this.limit,'Error');
				return;

			}

			if ( typeof tag === 'string' ) this.tag = tag;

			this.tag = this.tag.trim();

			if ( this.tag !== '' ) {

				if ( this.validator() ) {

					this.tags.push(this.tag);
					this.tag = '';
					this.needsUpdate = true;

				}

			}

		},

		saveTags () {
			
			if ( this.returnOnly ) {

				this.close(true);

			}
			else {

				this.updateLoadingText('Updating' + this.settings.type);

	            ApiService.put( 'formTags/'+this.settings.type+'/'+this.settings.formId, { tags: this.tags } )
	                .then( function( info ) {

	                    this.updateLoadingText('');

	                    general.apiResponse( info, function () {

	                        this.needsUpdate = false;
	                        this.$snotify.success('Your '+this.tagName+'s have been updated',this.tagName+'s');
	                        var s = { formData: [], updateId: this.settings.formId, field : this.settings.type };
	                        this.tags.forEach( function (tag) {
								s.formData.push(tag.toString());
							}.bind(this));
	                        this.addUpdateForm(s);

	                    }.bind(this));

	                }.bind(this))
	                .catch( function(a,b) {
	                    console.log('FAILURE!!',a,b);
	                }.bind(this));

            }

		},

		validator () {

			var tag = this.tag.trim();

			if ( this.lowerCaseTags ) {

				tag = this.tag.toLowerCase();

			}

			switch ( this.settings.type ) {

				case 'emails' :

					this.tag = this.tag.toLowerCase();

					var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.tag);

					if ( ok === false ) {

						this.$snotify.error('The email address isn\'t in the correct format', 'Add '+this.tagName);
						return false;

					}
					else if ( typeof this.domains !== 'undefined' ) {

						var domain = this.tag.split('@')[1];

						if ( this.domains.indexOf(domain) < 0 ) {

							this.$snotify.error('You can only add an email address from domains you have added and are valid', 'Add '+this.tagName);
							return false;

						}

					}

				break;

				case 'domains':

					const UrlPattern = require('url-pattern');
					const pattern = new UrlPattern('(http(s)\\://)(*.):domain.:tld(\\::port)(/*)');

					const match = pattern.match(this.tag);

					if ( match === null ) {

						this.$snotify.error('The domain isn\'t in the correct format', 'Add '+this.tagName);
						return false;

					}
					else {
						
						tag = match.domain + '.' + match.tld;

						if ( typeof match._ !== 'undefined' && match._.length > 0 ) {

							if ( typeof match._ === 'string' ) {

								tag = match._ + '.' + tag;

							}
							else {

								tag = match._[0] + '.' + tag;

							}

						}

						if ( typeof match.port !== 'undefined' ) {

							tag = tag + ':' + match.port;

						}

					}

				break;

				default :

					this.tag = this.tag.toLowerCase();

			}

			if ( this.tags.indexOf(tag) >= 0 ) {

				this.$snotify.error('The '+this.tagName+' already exists', 'Add '+this.tagName);
				return false;

			}

			this.tag = tag;

			return true;

		},

		close(save) {

			if ( ( typeof save === 'boolean' && save === true ) || this.settings.saveOnClose ) {

				var info = { tags: this.tags };

				if ( typeof this.settings.type !== 'undefined' ) info.type = this.settings.type;

				let returns = typeof this.settings.returns !== 'undefined' ? this.settings.returns : [];

				returns.forEach( function (v) {

					if ( typeof this.settings[v] !== 'undefined' ) {

						info[v] = this.settings[v];

					}

				}.bind(this));

				if ( typeof this.settings.initiator !== 'undefined' ) {

					let el = Array.isArray(this.settings.initiator) ? this.settings.initiator[0] : this.settings.initiator;

					let top = (el.offsetTop - el.scrollTop + el.clientTop);

					setTimeout( function () {

		                window.scrollTo( 0, top );

		            }, 1);

				}

				this.$emit('close-tagger',info);

			}
			else {

				this.$emit('close-tagger');

			}

		}
	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.available-tags {
	margin-top: 20px;
	text-align: left;
	h3 {
		margin-bottom: 5px;
	}
}
.current-tags {
	text-align: left;
}
.input-wrap {
	position: relative;
	[type=text] {
		padding-right: 40px;
	}
	.add-tag {
		display: block;
	    position: absolute;
	    top: 0;
	    right: 0;
	    background: #ccc;
	    color: #fff;
	    border-radius: 4px;
	    padding: 2px 4px 1px;
	    cursor: pointer;
	    .trans;
	    &:hover {
	    	background: black;
	    }
	}
}

form {

	[type=text] {

		margin-bottom: 10px;

	}

}

.large-button {

	&.save {

		width: 100%;

	}

}
@media screen and (min-width: 768px) {


	.large-button {

		&.save {

			position: absolute;
			top: 28px;
			z-index: 13;
			right: 27px;
			margin: 0;
			padding: 3px 0 2px;
			width: 140px;

		}

	}

	.input-wrap {
		[type=text] {
			padding-right: 160px;
		}
	}

}
</style>